import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";

import Students from "./students";
import util from "./companies/util";
import Tabs from "../../components/Tabs";
import CompanyForm from "./companies/Form";
import ContractForm from "./contracts/Form";
import ContractTabs from "./contracts/Tabs";
import CompaniesList from "./companies/List";
import ContractsList from "./contracts/List";
import ContractTitle from "./contracts/Title";
import CompaniesFilter from "./companies/Filter";
import ContractsFilter from "./contracts/Filter";
import ContactList from "./contracts/ContactList";
import { getLangAll } from "../../store/middleware";
import ContactSearch from "./contracts/ContactSearch";
import Header from "../../components/Header/NewHeader";
import ContactFormList from "./contracts/ContactFormList";
import SideMenu from "../../components/SideMenu/SideMenu";
import b2bImg from "../../assets/images/icons/icon_contract.svg";
import { setContract } from "../../store/slices/b2b/b2bContracts.slice";

import { Tab } from "./styles";
import { FilterUser } from "./companies/styles";

function B2B() {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [showDialog, setShowDialog] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [contactsFound, setContactsFound] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [activeTab, setActiveTab] = useState(t("COMPANY_INFO"));
  const [showCompanyForm, setShowCompanyForm] = useState(false);
  const [selectedContract, setSelectedContract] = useState(null);
  const [showContractForm, setShowContractForm] = useState(false);

  const loadInfos = () => {
    if (window.location.pathname === "/b2b/coupons") {
      setActiveTab(t("COUPONS_INFO"));
    }
    dispatch(getLangAll());
  };

  useEffect(() => {
    loadInfos();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    setShowCompanyForm(false);
    setShowContractForm(false);
    // eslint-disable-next-line
  }, [activeTab]);

  const deps = {
    util,
    setShowCompanyForm: setShowCompanyForm,
    setShowContractForm: setShowContractForm,
    setSelectedCompany: setSelectedCompany,
    setSelectedContract: setSelectedContract,
    setAlertMessage: setAlertMessage,
    setContactsFound: setContactsFound,
    contactsFound: contactsFound,
  };

  const handleOpenContractForm = () => {
    setSelectedContract(null);
    dispatch(
      setContract({
        code: "",
        description: "",
        companyId: 0,
        startDate: "",
        endDate: "",
        active: true,
        contractPlans: [],
        contractContacts: [],
      }),
    );

    setShowContractForm(true);
  };

  const options = [t("COMPANY_INFO"), t("CONTRACTS_INFO")];

  return (
    <div className="view">
      <SideMenu />
      <section>
        <Header
          title={"B2B"}
          icon={<img src={b2bImg} alt="B2b" />}
          typeIcon="custom"
          rightButton={
            options[0] === activeTab ? (
              <button className="buttonRight" type="button" onClick={() => setShowCompanyForm(true)}>
                <i className="fa fa-plus" aria-hidden="true" /> {t("ADD_NEW_COMPANY")}
              </button>
            ) : (
              <button className="buttonRight" type="button" onClick={() => handleOpenContractForm()}>
                <i className="fa fa-plus" aria-hidden="true" /> {t("Add New Contract")}
              </button>
            )
          }
        />

        <Tab>
          <div className="container">
            <Tabs activeTab={activeTab} options={options} setActiveTab={setActiveTab}>
              {options[0] === activeTab && (
                <div label={t("COMPANY_INFO")}>
                  {!showCompanyForm && (
                    <>
                      <FilterUser>
                        <div>
                          <CompaniesFilter {...deps} />
                        </div>
                      </FilterUser>

                      <CompaniesList {...deps} />
                    </>
                  )}

                  {showCompanyForm && (
                    <div>
                      <CompanyForm {...deps} selectedCompany={selectedCompany} />
                    </div>
                  )}
                </div>
              )}

              {options[1] === activeTab && (
                <div label={t("CONTRACTS_INFO")}>
                  {!showContractForm && (
                    <div>
                      <FilterUser>
                        <div>
                          <ContractsFilter {...deps} />
                        </div>
                      </FilterUser>
                      <ContractsList {...deps} />
                    </div>
                  )}

                  {showContractForm && (
                    <div>
                      <ContractTitle />
                      <ContractTabs>
                        <div label={t("CONTRACTS")}>
                          <ContractForm {...deps} selectedContract={selectedContract}>
                            <ContactSearch {...deps} />
                            <ContactList {...deps} selectedContract={selectedContract}>
                              <ContactFormList {...deps} />
                            </ContactList>
                          </ContractForm>
                        </div>
                        <div label="Students">
                          <Students {...deps} />
                        </div>
                      </ContractTabs>
                    </div>
                  )}
                </div>
              )}
            </Tabs>
          </div>
        </Tab>
        <Dialog open={showDialog} onClose={() => setShowDialog(false)} className="alert-dialog-slide">
          <DialogTitle className="alert-dialog-slide-title boxModal teste">{t("INVALID_FORM_TITLE")}</DialogTitle>
          <DialogContent className="alert-dialog-slide-content boxModal">{t(alertMessage)}</DialogContent>
          <br />

          <DialogActions className="alert-dialog-slide-actions buttons boxModal">
            <button onClick={() => setShowDialog(false)}>{t("OK")}</button>
          </DialogActions>
        </Dialog>
      </section>
    </div>
  );
}

export default B2B;
